document.addEventListener('click', async function(e) {
  if (!e.target.classList.contains('quick-size-btn')) return;
  if (e.target.classList.contains('sold-out') || e.target.disabled) return;
  
  e.preventDefault();
  e.stopPropagation();
  
  const button = e.target;
  const variantId = button.dataset.variantId;
  const originalText = button.textContent.trim();
  
  button.classList.add('adding');
  button.textContent = '...';
  
  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        items: [{ id: parseInt(variantId), quantity: 1 }]
      })
    });
    
    if (response.ok) {
      button.classList.remove('adding');
      button.classList.add('added');
      button.textContent = '✓';
      
      // Update cart count
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();
      
      // Update cart count bubble
      const cartCountEls = document.querySelectorAll('.CartCountBubble, [data-cart-count], .Header__CartCount');
      cartCountEls.forEach(el => { el.textContent = cart.item_count; });

      // Open cart drawer
      const cartDrawer = document.querySelector('section-cart-drawer');
      if (cartDrawer) cartDrawer._onProductAdded({ detail: { cart } });

      setTimeout(() => {
        button.classList.remove('added');
        button.textContent = originalText;
      }, 1500);
    } else {
      throw new Error('Failed to add to cart');
    }
  } catch (error) {
    console.error('Error adding to cart:', error);
    button.classList.remove('adding');
    button.classList.add('error');
    button.textContent = 'Error';
    setTimeout(() => {
      button.classList.remove('error');
      button.textContent = originalText;
    }, 2000);
  }
});